import debounce from 'lodash/debounce';
import {useCallback} from 'react';

const useDebounce = <T extends (...args: any) => any>(functionToDebounce: T, waitMillis = 300) =>
  useCallback(debounce(functionToDebounce, waitMillis), [functionToDebounce, waitMillis]);

export default useDebounce;
